import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import createdthhubmapping from '../Createdthhubmapping';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import AdminSettingsService from '../../../services/adminsettings.service';
import CONSTANT from '../../../../shared/constants/constant';
import Util from '../../../../shared/util/util';
import MasterService from '../../../../masterdata/services/masterdata.service';
import CryptoJS from 'crypto-js';
export default {
  name: 'DTHhubMapping',
  components: {
    Pagination,
    createdthhubmapping,
    Loader,
    Multiselect,
    CustomExpandableTable
  },
  data: function() {
    return {
      tableArr: [],
       selectedODAObj: '',
       type:'DTH_Mapping',
       isLoading:false,
       Loader:false,
       showcreatedthconfig: false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: [ 'Hub', 'Mother Hub', 'Status','Action'],
      innerTableColumn: ['Assigned Territory'],
      tableItems: [],
      hubaccessObjArray:[],
      hubids:null,
      motherhubArr:[],
      motherhubids:null,
      UpdateDTHMapping:"",
      actiontype:"",
      useremail: ""
    }
  },
  computed: {

  },
  mounted() {
  var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext);
  this.useremail = userdetail.email;
  this.getDTHMappingList();
  this.getHubAccessList();
  },
  methods: {
    async getHubAccessList() {
      try {
        let InputPayload = {};
      this.isLoading = true;
      let response = await MasterService.GetHublist(InputPayload);
      if(response.data.code===200){
        this.hubaccess = response.data.data.data;
        for (var i = 0; i < this.hubaccess.length; i++) {
          this.hubaccessObjArray.push({
            hubid: this.hubaccess[i].HubID,
            hubname: this.hubaccess[i].HubName
          })
        }
        this.motherhubArr = this.hubaccessObjArray
        }
        else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    showDTHMappingconfig() {
      this.selectedDTHObj = [];
      this.actiontype = "create"
      this.showcreatedthconfig = true;
      this.$validator.reset();
    },
    callParent() {
        this.showcreatedthconfig = false;
        this.currentPage = 1;
        this.offset = 0;
        this.getDTHMappingList();
      },
      searchDTHMapping: function(event) {
        this.$validator.validateAll().then((result) => {
          if(result){
            this.currentPage = 1;
            this.offset = 0;
            this.getDTHMappingList();
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
      },
      async getDTHMappingList() {
        this.isLoading = true
        this.totalCount=0;
        try {
          let inputPayload = {
            "offset": this.offset,
            "limit": this.pageLimit,
          }
          if (this.hubids) {
            inputPayload.hubid = this.hubids.hubid;
          } 
          if (this.motherhubids) {
            inputPayload.motherhubid = this.motherhubids.hubid;
          }     
          let result = await AdminSettingsService.getDTHhubMappingList(inputPayload);
          this.isLoading = false;
         
            if(result.data.code == 200){
              this.totalCount = result.data.data.count;
              this.tableArr = result.data.data.rows;
            this.tableItems = result.data.data.rows.map((el)=>{
              return {
                'id':el.id,
                'Hub':el.hubname,
                'Mother Hub': el.motherhubname,
                'Status': el.status,
                'Action': 'Need To Check1'
              }
            })
          }else{
            this.$alertify.error("No mother Hub mapped for"+" "+this.hubids.hubname);
            this.tableItems=[];
          }
          if (this.totalCount < this.pageLimit) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
          }
        } catch (err) {
          this.isLoading = false;
          console.log(err);
        }
      },
      onPageChange(page) {
        this.currentPage = page;
        this.offset = (page - 1) *this.pageLimit
        this.getDTHMappingList()
      },
      clearForm() {
        this.currentPage = 1;
        this.offset = 0;
        this.motherhubids = null;
        this.hubids = null;
        this.getDTHMappingList();
        this.$validator.reset();
      },
      getCustomTableEvent(event) {
        if(event.actionType=="active"){
          this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.activeAction(event);
         }).catch((err)=>{
           console.log(err)
         });
       }else if(event.actionType=="inactive"){
          this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.activeAction(event);
         }).catch((err)=>{
           console.log(err)
         })
        }
        if (event.actionType == "edit") {
          this.UpdateDTHMapping = this.tableArr.filter(function (Items) {
            return Items.id == event.id;
          });
          this.selectedDTHObj = this.UpdateDTHMapping;
          this.actiontype = "edit"
          this.showcreatedthconfig = true;
        }
      },
      async activeAction(data){
        try {
          this.isLoading = true;
          var item = this.tableArr.find(item => item.id === data.id);
          var isactivestatus = item.status == 0 ? 1 : 0
          let inputPayload = {
            "id": data.id,
            "type": this.type,
            "status": isactivestatus
          }
          let result = await MasterService.changeStatus(inputPayload)
          if(result.data.code == 200){
            if(result.data.data[0].status == 0){
              this.$alert("DTH Hub Mapping Activated Successfully!!", "DTH Hub Mapping", "success");
            }else{
              this.$alert("DTH Hub Mapping Inactivated Successfully!!", "DTH Hub Mapping", "success");
            }
            this.getDTHMappingList();
            this.isLoading = false;
          }
        } catch(err){
          console.log(err);
        }
      },
  }
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/hubmapping/dthhubmappingListing/dthhubmappingListing.component.js